/**
 * Route-aware launcher for AI Quick Add, rendered in the nav menu header (to the
 * right of the "Menu" title, so it sits right under the thumb after tapping the
 * hamburger). It only appears on a trip page (`/trips/$tripId`) — the seed of a
 * per-route "assistant" idea — and opens the trip-scoped `QuickAddModal` via the
 * store, already listening: the mic starts in this tap handler (iOS needs the
 * gesture). A compact primary-fill pill so it reads as an action, not a destination.
 */
import { useQuickAddStore } from '@/stores/quickAdd';
import { useMatchRoute } from '@tanstack/react-router';
import { Mic } from 'lucide-react';

export function QuickAddNavButton({ onLaunch }: { onLaunch: () => void }) {
  const matchRoute = useMatchRoute();
  const launchVoice = useQuickAddStore((s) => s.launchVoice);
  const onTripPage = matchRoute({ to: '/trips/$tripId' });
  if (!onTripPage) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => {
        onLaunch();
        launchVoice();
      }}
      className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-[var(--primary)] px-3 py-2 text-sm font-medium text-[var(--primary-foreground)] shadow-sm transition-colors hover:opacity-90"
    >
      <Mic className="h-4 w-4" />
      <span>Quick add</span>
    </button>
  );
}
